import { useQuery } from '@tanstack/react-query';
import { Box, LinearProgress, Paper, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { api } from '../api/client';
import type { TxRequest } from '../api/types';
import { PageHeader, TxHashLink, TxStatusChip } from '../components/common';

export function TxHistory() {
  const { data, isLoading } = useQuery({
    queryKey: ['tx-requests'],
    queryFn: () => api.get<TxRequest[]>('/tx-requests'),
  });

  return (
    <Box>
      <PageHeader crumb="서비스 사용자 · 거래" title="거래 · 요청 내역" desc="요청-트랜잭션 상태(tx_requests)와 해시입니다." />
      {isLoading && <LinearProgress />}
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>일시</TableCell>
              <TableCell>기능</TableCell>
              <TableCell>상태</TableCell>
              <TableCell>해시</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(data ?? []).map((t) => (
              <TableRow key={t.id} hover>
                <TableCell sx={{ fontFamily: 'monospace', fontSize: 12 }}>{new Date(t.requestedAt).toLocaleString()}</TableCell>
                <TableCell>
                  {t.action}
                  {t.revertReason && (
                    <Typography variant="caption" display="block" color="error">{t.revertReason}</Typography>
                  )}
                </TableCell>
                <TableCell><TxStatusChip status={t.status} /></TableCell>
                <TableCell><TxHashLink hash={t.txHash} /></TableCell>
              </TableRow>
            ))}
            {data?.length === 0 && (
              <TableRow><TableCell colSpan={4} align="center" sx={{ color: 'text.secondary', py: 4 }}>내역이 없습니다.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
}
